import React from 'react'
import { Outlet, useNavigation } from 'react-router-dom'

import {LoadingOverlay} from "../Components/Generic/LoadingOverlay";

const AuthRoutes = () => {

    const { state } = useNavigation()

    if (state === 'loading') {
        return <LoadingOverlay open />
    }

    return <Outlet />
}

export {AuthRoutes}
